import {FieldRenderProps} from "@progress/kendo-react-form"
import {Input} from "@progress/kendo-react-inputs"
import React from "react"

const TextInputField = (fieldRenderProps: FieldRenderProps) => {
    const {name, label, value, disabled, onChange, tabIndex, valid} = fieldRenderProps
    return (
        <Input
            id={`bk_input_${name}`}
            name={name}
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            tabIndex={tabIndex}
            valid={valid}
        />
    )
}

export default React.memo(TextInputField)
